import {Component, inject, PLATFORM_ID} from '@angular/core';
import {HomeDigitsComponent} from './home-digits/home-digits.component';
import {HomeTopComponent} from './home-top/home-top.component';
import {HomeLetsMeetComponent} from './home-lets-meet/home-lets-meet.component';
import {HomeWhyComponent} from './home-why/home-why.component';
import {HomeEventsComponent} from './home-events/home-events.component';
import {HomeAmbianceComponent} from './home-ambiance/home-ambiance.component';
import {HomeTestimoniesComponent} from './home-testimonies/home-testimonies.component';
import {HomeProgramComponent} from './home-program/home-program.component';
import {HomeOffersComponent} from './home-offers/home-offers.component';
import {HomeFaqComponent} from './home-faq/home-faq.component';
import {FooterComponent} from '../footer/footer.component';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {HomeGaleryComponent} from './home-galery/home-galery.component';


@Component({
  selector: 'app-home',
  imports: [
    HomeDigitsComponent,
    HomeTopComponent,
    HomeLetsMeetComponent,
    HomeWhyComponent,
    HomeEventsComponent,
    HomeAmbianceComponent,
    HomeTestimoniesComponent,
    HomeProgramComponent,
    HomeOffersComponent,
    HomeFaqComponent,
    FooterComponent,
    HomeGaleryComponent
  ],
  styleUrls: ['./home.component.scss'],
  templateUrl: './home.component.html'
})
export class HomeComponent {
  title = inject(Title)
  platformId = inject(PLATFORM_ID)
  route = inject(ActivatedRoute)

  constructor() {

  }
}
